export interface MockEWBItem {
    itemId: string;
    itemName: string;
    hsnCode: string;
    qty: number;
    unit: string;
    taxableValue: number;
    taxRate: number;
}

export interface MockEWayBill {
    id: string;
    ewbNumber: string;
    invoiceId: string | null;
    challanId: string | null;
    invoiceNumber: string;
    customerName: string;
    supplierName: string;
    generatedDate: string;
    validUntil: string;
    validityDays: number;
    distanceKm: number;
    fromGSTIN: string;
    toGSTIN: string;
    fromAddress: string;
    toAddress: string;
    transporterId: string | null;
    transporterName: string | null;
    vehicleNumber: string | null;
    vehicleType: 'ROAD' | 'RAIL' | 'AIR' | 'SHIP';
    transportMode: '1' | '2' | '3' | '4';
    totalValue: number;
    totalTaxableValue: number;
    cgst: number;
    sgst: number;
    igst: number;
    status: 'ACTIVE' | 'CANCELLED' | 'EXPIRED' | 'EXTENDED';
    cancelledAt: string | null;
    cancelReason: string | null;
    generatedBy: string;
    items: MockEWBItem[];
}

export const mockEWayBills: MockEWayBill[] = [
    {
        id: 'ewb-001',
        ewbNumber: '231234567891',
        invoiceId: 'si-001',
        invoiceNumber: 'INV-2024-0001',
        challanId: null,
        customerName: 'Metro Industries',
        supplierName: 'InvenPro Manufacturing Pvt Ltd',
        generatedDate: '2024-04-15T10:30:00Z',
        validUntil: '2024-04-16T23:59:59Z',
        validityDays: 1,
        distanceKm: 150,
        fromGSTIN: '27AABCU9603R1ZX',
        toGSTIN: '29ABCDE1234F1Z5',
        fromAddress: 'Main Warehouse, Mumbai, Maharashtra',
        toAddress: 'Customer Address, Bangalore, Karnataka',
        transporterName: 'Fast Logistics Pvt Ltd',
        transporterId: 'TRAN001',
        vehicleNumber: 'MH 04 AB 1234',
        vehicleType: 'ROAD',
        transportMode: '1',
        totalValue: 75000,
        totalTaxableValue: 63560,
        cgst: 0,
        sgst: 0,
        igst: 11440,
        status: 'ACTIVE',
        cancelledAt: null,
        cancelReason: null,
        generatedBy: 'Admin User',
        items: [
            {
                itemId: 'itm-018',
                itemName: 'Industrial Pump X',
                hsnCode: '84137000',
                qty: 5,
                unit: 'Pcs',
                taxableValue: 63560,
                taxRate: 18,
            },
        ],
    },
    {
        id: 'ewb-002',
        ewbNumber: '231234567892',
        invoiceId: 'si-002',
        invoiceNumber: 'INV-2024-0002',
        challanId: null,
        customerName: 'Sharma Traders',
        supplierName: 'InvenPro Manufacturing Pvt Ltd',
        generatedDate: '2024-04-10T09:00:00Z',
        validUntil: '2024-04-10T23:59:59Z',
        validityDays: 1,
        distanceKm: 80,
        fromGSTIN: '27AABCU9603R1ZX',
        toGSTIN: '27AABCD1234E1Z5',
        fromAddress: 'Main Warehouse, Mumbai, Maharashtra',
        toAddress: 'Customer Address, Pune, Maharashtra',
        transporterName: null,
        transporterId: null,
        vehicleNumber: 'MH 12 CD 5678',
        vehicleType: 'ROAD',
        transportMode: '1',
        totalValue: 32000,
        totalTaxableValue: 27120,
        cgst: 2440,
        sgst: 2440,
        igst: 0,
        status: 'EXPIRED',
        cancelledAt: null,
        cancelReason: null,
        generatedBy: 'Admin User',
        items: [
            {
                itemId: 'itm-017',
                itemName: 'Gear Assembly A',
                hsnCode: '84839000',
                qty: 10,
                unit: 'Pcs',
                taxableValue: 27120,
                taxRate: 18,
            },
        ],
    },
    {
        id: 'ewb-003',
        ewbNumber: '231234567893',
        invoiceId: 'si-003',
        invoiceNumber: 'INV-2024-0003',
        challanId: null,
        customerName: 'Delhi Distributors',
        supplierName: 'InvenPro Manufacturing Pvt Ltd',
        generatedDate: '2024-04-20T11:00:00Z',
        validUntil: '2024-04-22T23:59:59Z',
        validityDays: 2,
        distanceKm: 320,
        fromGSTIN: '27AABCU9603R1ZX',
        toGSTIN: '06ABCDE5678F1Z2',
        fromAddress: 'Main Warehouse, Mumbai, Maharashtra',
        toAddress: 'Customer Address, Delhi, Delhi',
        transporterName: 'Bluedart Express',
        transporterId: 'TRAN002',
        vehicleNumber: 'DL 01 EF 9012',
        vehicleType: 'ROAD',
        transportMode: '1',
        totalValue: 120000,
        totalTaxableValue: 101695,
        cgst: 0,
        sgst: 0,
        igst: 18305,
        status: 'CANCELLED',
        cancelledAt: '2024-04-20T15:00:00Z',
        cancelReason: 'Wrong vehicle assigned',
        generatedBy: 'Admin User',
        items: [],
    },
];